import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Design icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Design } from '@sravni/design-system-icons'
 *
 * <Design />
 * ```
 */
var Design = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Design", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.167 11.667C3.246 11.667 2.5 10.92 2.5 10V4.167c0-.921.746-1.667 1.667-1.667H10c.92 0 1.667.746 1.667 1.667M10.844 6.804a5.43 5.43 0 0 1 6.519 6.518 5.375 5.375 0 0 1-4.04 4.04 5.43 5.43 0 0 1-6.519-6.518 5.375 5.375 0 0 1 4.04-4.04v0Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M11.667 9.167V10c0 .92-.746 1.667-1.667 1.667h-.833", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Design };
//# sourceMappingURL=Design.js.map
